<template>
    <div class="page white_bg">
        <div style="height: 46px;">
            <header class="pageHeader detailPageHeader white_bg paddingH16 paddingV8" style="line-height: 30px;">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;"
                                  @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{ title }}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">

            <personalHeader :userInfo="dataItem"/>

            <div class="font14r clearfix" style="padding: 0 12px 0 30px; line-height: 35px;">
                <span>账号余额：</span>
                <router-link class="floatR" :to="{ name:'agencyRecharge'}">
                    <span class="orange2" >xx个</span>
                    &gt;
                </router-link>
            </div>

            <van-tabs v-model="tabModule.activeIndex" sticky swipeable
                      title-inactive-color="#101010" title-active-color="#F28500"
                      line-width="0" line-height="0" style="border-top: solid 1px #BBB;">
                <van-tab title="账号管理">
                    <accountManage/>
                </van-tab>

                <van-tab title="账号购买">

                </van-tab>

            </van-tabs>

        </div>

        <div style="height: 51px;"></div>
    </div>
</template>

<script>
import {Tab, Tabs} from 'vant';
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from "@/appConfig";

// modules
import personalHeader from "./personalHeader";

import vipApi from '@/api/vip';
import VipTypeBroadSenseEnum from '@/data/VipTypeBroadSenseEnum';
import accountManage from "./accountManage";

// util
import appHelper    from '../../util/appHelper';
import userUtil     from "../shixunApp/userUtil";
import consoleHelper from "@util/consoleHelper";
import wechatHelper from "@util/wechatHelper";

const config = {
    apiConfig: {
        get: {
            url: 'portal/v2/distribution/agency/get/info',
            dataPath : 'data'
        }
    }
};

export default {
    name: "kindergartenVipPersonalCenter",
    extends: shixunPagePart,
    components: {
        'van-tab': Tab,
        'van-tabs': Tabs,
        personalHeader,
        accountManage
    },
    data() {
        return {
            title: '园所会员中心',
            apiConfig: config.apiConfig,
            enableDataList: true,
            enableDataItem: true,
            tabModule: {
                activeIndex: 0
            },

            vipDueTime : '',
            vipEnjoyData : null
        }
    },
    methods: {
        back: function () {
            appHelper.redirect('/me');
        },
        onLoadDataItem() {

            // log
            // consoleHelper.log('');
            // consoleHelper.log('代理商基本信息：');
            // consoleHelper.log('-- 姓名：' + this.dataItem.userName);
            // consoleHelper.log('-- 创建日期：' + this.formatDate(this.dataItem.createTime));
            // consoleHelper.log('-- 有效期：' + this.formatDate(this.dataItem.expireTime));
            // consoleHelper.log('-- 团队成员数：' + this.dataItem.teamSize);
            // consoleHelper.log('-- 团队总收益：￥' + this.dataItem.totalIncome);

            // const wechatShareOptions = {
            //     title   : '邀请码+合伙人邀请你一起成为师讯会员，快去加入吧！',
            //     // desc    : this.description,
            //     link : appHelper.generateShareUrl('/auth/distributorAuth/promotion/:promotionCode', {
            //         ':promotionCode' : this.userInstance.introduceCode
            //     }),
            //     imgUrl  : appHelper.getAppIcon() // 分享图标
            // };
            // consoleHelper.log('');
            // consoleHelper.log('[wechat] wechatShareOptions:');
            // consoleHelper.log(wechatShareOptions);
            // wechatHelper.setShare(wechatShareOptions);

        }
    },
    mounted() {

        const me = this;

        this.loadDataItem();

        if (appConfig.mode == "demo") {
            this.dataItem = {
                id: 1,
                certification : []
            };

            for (let j = 0; j < 3; j++) {
                this.dataItem.certification.push(appHelper.getRandomCoverImage());
            }
        }
        else
        {
            appHelper.needLogin((user) => {
                this.userInstance = userUtil.createUser(user);
                this.vipDueTime = user.vipDueTime['4'];
            });
        }

        vipApi.loadVipEnjoyInfo(VipTypeBroadSenseEnum.AGENCY.code, (result) => {
            me.vipEnjoyData = result.data;
        });
    }
}
</script>

<style lang="scss" scoped>
.orange {
    color: #F28500;
}
.orange2 {
    color: #E99D42;
}

.tabModule {
    .tabItem {
        padding: 13px 0 10px;
        color: #8994A9;

        &.active {
            color: #FFA724;

            &:before {
                content: '';
                display: block;
                position: absolute;
                width: 19px;
                height: 2px;
                left: 50%;
                margin-left: -9px;
                bottom: 4px;
                background: #FFA724;
                border-radius: 2px;
            }
        }
    }
}

.vipIcon {
    width: 32px;
    height: 14px;
    background-image: url('data:image/png;base64,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');
}
.roleLabel {
    padding: 0 8px;
    height: 27px;
    line-height: 27px;
    font-size: 14px;
    text-align: center;
    background: transparent;
    border: solid 1px #BBBBBB;
    color: #101010;
}
.orangeButton {
    background: #F7AA01;
    color: white;
    height: 40px;
    line-height: 40px;
    border-radius: 16px;
}
</style>
